module.exports = __webpack_public_path__ + "img/some.46b00799.png";